import config from "../config.json";

const Config = {
  API_ROOT: config.api_root
};

export default Config;
